module.exports = __webpack_public_path__ + "static/media/add-icon-toolbar.90406ba6.svg";